module.exports = __webpack_public_path__ + "static/media/opensans-extrabold.10333f97.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/opensans-extrabold.woff2
// module id = 297
// module chunks = 0